import type {
  ChangeEvent,
  DragEvent,
  KeyboardEvent,
  RefObject,
} from 'react'

import { TalentPoolFaqSection } from './talent-pool-faq-section'
import { TalentPoolFinalCtaFooterSection } from './talent-pool-final-cta-footer-section'
import { TalentPoolHowItWorksSection } from './talent-pool-how-it-works-section'
import { TalentPoolPerksSection } from './talent-pool-perks-section'
import { TalentPoolRecruiterSection } from './talent-pool-recruiter-section'
import { TalentPoolSecuritySection } from './talent-pool-security-section'
import { TalentPoolLandingUploadSection } from './talent-pool-landing-upload-section'
import type { UploadPickerTrigger } from './talent-pool-page-types'

type TalentPoolLandingContentProps = {
  file: File | null
  storedFileName: string | null
  isDragging: boolean
  submitError: string
  canGoToPersonal: boolean
  fileInputRef: RefObject<HTMLInputElement | null>
  onDragOver: (event: DragEvent<HTMLDivElement>) => void
  onDragLeave: () => void
  onDrop: (event: DragEvent<HTMLDivElement>) => void
  onOpenPicker: (trigger: UploadPickerTrigger) => void
  onUploadAreaKeyDown: (event: KeyboardEvent<HTMLDivElement>) => void
  onFileInputChange: (event: ChangeEvent<HTMLInputElement>) => void
  onRemoveFile: () => Promise<void>
  onLandingNext: () => void
  onScrollToUpload: () => void
}

export function TalentPoolLandingContent({
  file,
  storedFileName,
  isDragging,
  submitError,
  canGoToPersonal,
  fileInputRef,
  onDragOver,
  onDragLeave,
  onDrop,
  onOpenPicker,
  onUploadAreaKeyDown,
  onFileInputChange,
  onRemoveFile,
  onLandingNext,
  onScrollToUpload,
}: TalentPoolLandingContentProps) {
  return (
    <>
      <TalentPoolLandingUploadSection
        file={file}
        storedFileName={storedFileName}
        isDragging={isDragging}
        submitError={submitError}
        canGoToPersonal={canGoToPersonal}
        fileInputRef={fileInputRef}
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
        onOpenPicker={onOpenPicker}
        onUploadAreaKeyDown={onUploadAreaKeyDown}
        onFileInputChange={onFileInputChange}
        onRemoveFile={onRemoveFile}
        onLandingNext={onLandingNext}
      />
      <TalentPoolHowItWorksSection onScrollToUpload={onScrollToUpload} />
      <TalentPoolSecuritySection />
      <TalentPoolRecruiterSection />
      <TalentPoolPerksSection />
      <TalentPoolFaqSection />
      <TalentPoolFinalCtaFooterSection onScrollToUpload={onScrollToUpload} />
    </>
  )
}
